// "Items" tab of the WM Transaction Management Data Profile form — Delphi TabSheet2, the same "Default
// Colors" block for the Transaction Management screen's items grid.
//
// Same shape as the Transactions tab, measured against a quantity rather than a date. The Delphi
// defaults are deliberately asymmetric with that tab's (50 Pending / 0 Warning here, 5 / 1 there);
// reproduced as read, in Form.js.
//
// Note the label: the Delphi form's own caption for ITEMTABPENDINGLEVEL reads 'Hours', which is a
// copy/paste leftover from the Transactions tab — the column's DisplayLabel is 'Quantity' and the
// value is a quantity. 'Quantity' is used here.
import { TABLE_NAME } from "./CodeLists";

export const ItemsTabLayout = [
    {
        "groupId": 1,
        "label": "Default Colors",
        "fields": [
            {
                "name": "ItemTabUseColors",
                "tableName": TABLE_NAME,
                "label": "Use Color",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ItemTabBasisQty",
                "tableName": TABLE_NAME,
                "label": "Basis Qty",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ],
    },
    {
        "groupId": 2,
        "label": "Pending",
        "fields": [
            {
                "name": "ItemTabPendingLevel",
                "tableName": TABLE_NAME,
                "label": "Quantity",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ItemTabPendingColor",
                "tableName": TABLE_NAME,
                "label": "Color",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ],
    },
    {
        "groupId": 3,
        "label": "Warning",
        "fields": [
            {
                "name": "ItemTabWarningLevel",
                "tableName": TABLE_NAME,
                "label": "Warning Qty",
                "type": "number",
                "format": "#,###0.00",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ItemTabWarningColor",
                "tableName": TABLE_NAME,
                "label": "Warning Color",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ],
    },
];
